import { Row, Typography } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { StatusTag } from './StatusTag';

const { Text } = Typography;

interface ProgramNameWithStatusProps {
  name: string;
  status: string;
  programId: number;
}

export const ProgramNameWithStatus: React.FC<ProgramNameWithStatusProps> = ({
  name,
  status,
  programId,
}) => {
  const navigate = useNavigate();
  const handleShowProgram = async () => {
    navigate(`/programs/v2/create-or-update/${programId}`);
  };
  return (
    <Row justify='space-between' onClick={handleShowProgram}>
      <Text style={{ cursor: 'pointer' }}>{name}</Text>
      <StatusTag status={status} />
    </Row>
  );
};
